import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { ArrowRight, Video, CalendarClock, Sparkles } from "lucide-react";

export default function Onboarding() {
  const { user } = useAuth();
  const navigate = useNavigate();
  return (
    <div className="max-w-3xl mx-auto py-10" data-testid="onboarding-page">
      <p className="bloq-eyebrow">Welcome to Bloq</p>
      <h1 className="bloq-display text-5xl mt-2 mb-3">
        Hi {user?.name?.split(" ")[0] || "there"} — your workspace is ready.
      </h1>
      <p className="text-lg text-[#4a4a52] mb-10 max-w-xl">
        Here are three things to do in the next two minutes. Each one takes about 20 seconds.
      </p>
      <div className="flex flex-col gap-3">
        {[
          { icon: Video, t: "Start your first instant meeting", d: "Test the lobby, camera, and host controls.", href: "/app", testid: "onboarding-start-instant" },
          { icon: CalendarClock, t: "Set up your first booking link", d: "Share it with a client — done.", href: "/app/bookings", testid: "onboarding-setup-booking" },
          { icon: Sparkles, t: "Try generating an AI summary", d: "End a meeting and watch Claude do the recap.", href: "/app/meetings", testid: "onboarding-try-ai" },
        ].map((s, i) => {
          const I = s.icon;
          return (
            <Link
              key={i}
              to={s.href}
              data-testid={s.testid}
              className="bloq-card p-5 flex items-center gap-4 hover:-translate-y-0.5 transition-transform"
            >
              <span className="w-11 h-11 rounded-lg flex items-center justify-center flex-shrink-0" style={{ background: "rgba(0,94,122,0.1)", color: "#005e7a" }}>
                <I className="w-5 h-5" />
              </span>
              <div className="flex-1">
                <p className="font-semibold">{s.t}</p>
                <p className="text-xs text-[#82828c]">{s.d}</p>
              </div>
              <ArrowRight className="w-4 h-4 text-[#82828c]" />
            </Link>
          );
        })}
      </div>
      <button onClick={() => navigate("/app")} className="bloq-btn-secondary mt-8" data-testid="onboarding-skip">
        Skip — take me to the dashboard
      </button>
    </div>
  );
}
